export default __webpack_public_path__ + "static/media/Kalulu_name.8add852f.jpg";